import React, { useState } from "react";
import { Paperclip, Send, X } from "lucide-react";
import { request } from "../../api/client";

export default function ChatAttachmentUpload({ botId, conversationId, disabled, onUploaded }) {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const send = async () => {
    if (!file || busy) return;
    setBusy(true);
    setError("");
    try {
      const form = new FormData();
      form.append("upload", file);
      await request(`/bots/${encodeURIComponent(botId)}/files/conversations/${conversationId}/send`, { method: "POST", data: form });
      setFile(null);
      await onUploaded();
    } catch (err) {
      setError(err.details?.detail || err.message || "Attachment could not be sent.");
      await onUploaded();
    } finally { setBusy(false); }
  };
  return (
    <div className="border-t border-slate-200 bg-white px-4 py-2">
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <label className={`inline-flex items-center gap-1 ${disabled || busy ? "opacity-50" : "cursor-pointer"}`}>
          <Paperclip size={16} />Attach file
          <input className="sr-only" type="file" aria-label="Attach chat file" disabled={disabled || busy} onChange={(event) => {
            const selected = event.target.files?.[0];
            event.target.value = "";
            setError("");
            if (selected?.size > 25 * 1024 * 1024) { setError("File must be 25 MB or smaller."); setFile(null); }
            else setFile(selected || null);
          }} />
        </label>
        {file && <>
          <span className="min-w-0 break-all">{file.name}</span>
          <button type="button" aria-label="Remove selected file" title="Remove selected file" disabled={busy} onClick={() => setFile(null)}><X size={16} /></button>
          <button type="button" disabled={disabled || busy} onClick={send} className="inline-flex items-center gap-1 rounded bg-blue-600 px-3 py-1 text-white"><Send size={14} />{busy ? "Uploading…" : "Upload & send"}</button>
        </>}
      </div>
      {error && <div role="alert" className="mt-1 text-xs text-red-700">{error}</div>}
    </div>
  );
}